import { Typography, Grid, IconButton, Stack, Alert } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import FlashLogo from "../../../../assests/svg/flash-coin.svg";
import { PRIVACY_PDF as PrivacyPDF, LEGAL_NOTICE_PDF as LegalNotice, getWhitepaperPdf } from "../../docs";
import { useSelector } from "react-redux";
import { Languagemodel } from "../../../../Slice/translateSlice";
import axios from "axios";
import Flag1 from "../../../../assests/Images/flag1.png"
import Flag2 from "../../../../assests/Images/flag3.png"
import Flag3 from "../../../../assests/Images/flag4.png"

import { Link } from "react-router-dom";
import { scrollToSection } from "../../utils/scrollToSection";

const Footer = () => {
  const languageState = useSelector((state) => state.translate.mode)

  const list1 = [
    {
      url: "Our Services",
      link: "services",
    },
    {
      url: "Roadmap",
      link: "roadmap",
    },
    {
      url: "App",
      link: "transfer",
    },
    {
      url: "Tokenomics",
      link: "tokenomics",
    },

    {
      url: "NFT",
      link: "nft",
    },
    {
      url: "Partners",
      link: "partners",
    },

    {
      url: "Team",
      link: "team",
    },
    {
      url: "FAQ",
      link: "faq",
    },
    {
      url: "Contact",
      link: "Contact",
    },
  ];
  const list2 = [
    {
      url: "Whitepaper",
      link: "whitepaper",
    },
    {
      url: "Audit",
      link: "tokenomics",
    },
    {
      url: "Press & Brand Kit",
      href: "/press",
    },
  ];
  const list3 = [
    {
      url: "Privacy Policy",
      link: PrivacyPDF
    },
    {
      url: "Legal Notice",
      link: LegalNotice
    },
  ];
  const lang = useSelector(Languagemodel)
  const LanguageState = useSelector((state) => state.translate.mode)
  const [messageStatus, SetmessageStatus] = React.useState(<></>);
  const [emailAddress, setEmailAddress] = React.useState('');
  const [captchaQuestion, setCaptchaQuestion] = React.useState('');
  const [captchaToken, setCaptchaToken] = React.useState('');
  const [captchaAnswer, setCaptchaAnswer] = React.useState('');
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const loadCaptcha = React.useCallback(async () => {
    try {
      const res = await axios.get("/sendgrid/captcha.php");
      const data = res.data;
      if (data?.error || !data?.token) {
        throw new Error("captcha");
      }
      setCaptchaQuestion(data.question);
      setCaptchaToken(data.token);
      setCaptchaAnswer('');
    } catch {
      setCaptchaQuestion('');
      setCaptchaToken('');
    }
  }, []);

  React.useEffect(() => {
    loadCaptcha();
  }, [loadCaptcha]);

  const showAlert = (severity, text) => {
    SetmessageStatus(
      <Alert
        variant="filled"
        severity={severity}
        style={{
          margin: "auto",
          width: "100%",
          position: "absolute",
          zIndex: "999999999",
          height: "50px",
          display: "flex",
          visibility: 'initial',
        }}
        className="AlertSetting"
      >
        {text}
      </Alert>
    );
    setTimeout(() => {
      SetmessageStatus(<></>);
    }, 4000);
  };

  const subscribeHandler = async () => {
    if (!emailAddress) {
      showAlert('error', lang['Email is required!'] || 'Email is required!');
      return false;
    }
    if (!captchaToken || captchaAnswer === '') {
      showAlert('error', lang['Anti-spam answer required'] || 'Anti-spam answer required');
      return false;
    }
    setIsSubmitting(true);
    try {
      const res = await axios.post('/sendgrid/subscribe.php', {
        emailAddress,
        captchaToken,
        captchaAnswer: Number(captchaAnswer),
        website: '',
        company: '',
      });
      showAlert(
        'success',
        lang['Your message has been sent!'] || 'Subscribed'
      );
      setEmailAddress('');
      await loadCaptcha();
    } catch (err) {
      const apiMsg = err?.response?.data?.message;
      let text = lang['Error sending message!'] || 'Error sending message!';
      if (apiMsg && String(apiMsg).toLowerCase().includes('captcha')) {
        text = lang['Incorrect anti-spam answer'] || 'Incorrect anti-spam answer';
      }
      showAlert('error', text);
      await loadCaptcha();
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <>
      <Stack
        sx={{
          width: "300px",
          position: "fixed",
          top: "90%",
          zIndex: 9999999,
          right: "10px",
        }}
        spacing={2}
      >
        
        {messageStatus}
      </Stack>
      <Grid
        container
        sx={{
          height: { lg: "450px", xs: "auto" },
          display: "flex",
          justifyContent: "center",
          color: "white",
          maxWidth: "100%",
          width: { lg: "1400px", xs: "100%" },
          padding: { lg: "0px 20px", xs: " 0px 0px" },
          margin: "auto",
          transform: { lg: "scale(0.8)", xs: "scale(none)" },
        }}
      >
        <Grid
          item
          xs={12}
          md={12}
          sx={{
            display: "flex",
            // alignItems: "center",
            flexDirection: { lg: "row", xs: "column" },
            mt: { lg: "50px", xs: "10px" },
            padding: { lg: "0", xs: "0px 30px" },
            justifyContent: "center",
          }}
        >
          <Grid
            item
            xs={11}
            md={4}
            sx={{ padding: { lg: "0px 100px 0 0", xs: "0px 0px 0 0px" } }}
          >
            <Box
              sx={{
                mt: "20px",
                display: "flex",
                flexDirection: "row",
                alignItems: 'center',
              }}
            >
              <Box>
                <img src={FlashLogo} width="40" height="40" alt="Flash Technologies" />
              </Box>

              <Typography
                sx={{
                  ml: "10px",
                  fontFamily: "'Manrope' !important",
                  fontSize: "22px !important",
                  fontWeight: "800 !important",
                  lineHeight: "30px !important",
                  marginBottom: '4px'
                }}
              >
                {lang["Flash Technologies"]}
              </Typography>
            </Box>
            <Typography
              sx={{
                marginTop: "37px",
                fontFamily: "'Manrope' !important",
                fontSize: "16px !important",
                fontWeight: "400 !important",
                lineHeight: "170% !important",
                color: "#85898F",
                display: 'flex',
                flexDirection: 'row',
                gap: '10px'
              }}
            >
              <Box>
                <img src={Flag3} />
              </Box>
              {lang["Flash Technologies : Business Center 1, M Floor, The Meydan Hotel, Nad Al Sheba, Dubai, U.A.E."]}
            </Typography>
            <Typography
              sx={{
                marginTop: "37px",
                fontFamily: "'Manrope' !important",
                fontSize: "16px !important",
                fontWeight: "400 !important",
                lineHeight: "170% !important",
                color: "#85898F",
                display: 'flex',
                flexDirection: 'row',
                gap: '10px'
              }}
            >
              <Box>
                <img src={Flag1} />
              </Box>
              {lang["Flash Technologies : 66 Avenue Des Champs Elysées,  75008, Paris."]}
            </Typography>
            <Typography
              sx={{
                marginTop: "37px",
                fontFamily: "'Manrope' !important",
                fontSize: "16px !important",
                fontWeight: "400 !important",
                lineHeight: "170% !important",
                color: "#85898F",
                display: 'flex',
                flexDirection: 'row',
                gap: '10px'
              }}
            >
              <Box>
                <img src={Flag2} />
              </Box>
              {lang["Flash Technologies : Abidjan-Cocody, Les II Plateaux, 7ème Tranche, Abidjan."]}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
            sx={{
              display: "flex",
              // alignItems: "center",
              flexDirection: { lg: "row", xs: "column" },
              // justifyContent: "center",
            }}
          >
            <Grid
              item
              md={4}
              xs={12}
              sx={{
                display: "flex",

                alignItems: "start",
                flexDirection: "column",
                // justifyContent: "center",
              }}
            >
              <Box>
                <Typography
                  sx={{
                    marginTop: { lg: "0px", xs: "20px" },
                    fontFamily: "'Manrope' !important",
                    fontSize: "18px !important",
                    fontWeight: "600 !important",
                    lineHeight: "160% !important",
                  }}
                >
                  {lang["Pages"]}
                </Typography>
                {list1.map((i) => {
                  return (
                    <Box key={i.url}>
                        <Box
                          style={{
                            textDecoration: "none",
                            color: "#85898F",
                          }}
                        >
                          <Typography
                            sx={{
                              marginTop: "10px",
                              fontFamily: "'Manrope' !important",
                              fontSize: "16px !important",
                              fontWeight: "400 !important",
                              lineHeight: "170% !important",
                              color: "#85898F",
                            }}
                          >
                            <div
                              className="menu-link"
                              role="link"
                              tabIndex={0}
                              onClick={() => {
                                if (i.url === "Whitepaper") {
                                  window.open(getWhitepaperPdf(languageState));
                                  return;
                                }
                                scrollToSection(i.link);
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                  e.preventDefault();
                                  scrollToSection(i.link);
                                }
                              }}
                            >
                              {lang[i.url]}
                            </div>
                          </Typography>
                        </Box>
                      </Box>
                  );
                })}
              </Box>
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
              sx={{
                display: "flex",

                alignItems: "start",
                flexDirection: "column",
                // justifyContent: "center",
              }}
            >
              <Box>
                

                <Typography
                  sx={{
                    marginTop: { lg: "0px", xs: "20px" },
                    fontFamily: "'Manrope' !important",
                    fontSize: "18px !important",
                    fontWeight: "600 !important",
                    lineHeight: "160% !important",
                  }}
                >
                  {lang["Documents"]}
                </Typography>
                {list2.map((i) => {
                  return (
                    <Box key={i.url}>
                        <Box
                          style={{
                            textDecoration: "none",
                            color: "#85898F",
                          }}
                        >
                          <Typography
                            sx={{
                              marginTop: "10px",
                              fontFamily: "'Manrope' !important",
                              fontSize: "16px !important",
                              fontWeight: "400 !important",
                              lineHeight: "170% !important",
                              color: "#85898F",
                            }}
                          >
                            {i.href ?
                              <Link className="menu-link" to={i.href}>
                                {lang[i.url] || i.url}
                              </Link> :
                            i.url === 'Become a Partner' ?
                              <a className="menu-link" id="become_a_partner1" target="_blank" rel="noreferrer"
                                href={`${LanguageState == 'fr' ? 'https://tcjpmvkkcyv.typeform.com/to/ILnGtfxh' : 'https://tcjpmvkkcyv.typeform.com/to/De146S9S'}`}
                              >
                                {lang[i.url]}
                              </a> :
                              <div
                                className="menu-link"
                                role="link"
                                tabIndex={0}
                                onClick={() => {
                                  if (i.url === "Whitepaper") {
                                    window.open(getWhitepaperPdf(languageState));
                                    return;
                                  }
                                  scrollToSection(i.link);
                                }}
                              >
                                {lang[i.url]}
                              </div>
                            }
                          </Typography>
                        </Box>
                      </Box>
                  );
                })}
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
              sx={{
                display: "flex",
                alignItems: "start",
                flexDirection: "column",
                // justifyContent: "center",
              }}
            >
              <Box>
                

                <Typography
                  sx={{
                    marginTop: { lg: "0px", xs: "20px" },
                    fontFamily: "'Manrope' !important",
                    fontSize: "18px !important",
                    fontWeight: "600 !important",
                    lineHeight: "160% !important",
                  }}
                >
                  {lang["Legal"]}
                </Typography>
                {list3.map((i) => {
                  return (
                    <Box key={i.url}>
                        <Box
                          style={{
                            textDecoration: "none",
                            color: "#85898F",
                          }}
                        >
                          <Typography
                            sx={{
                              marginTop: "10px",
                              fontFamily: "'Manrope' !important",
                              fontSize: "16px !important",
                              fontWeight: "400 !important",
                              lineHeight: "170% !important",
                              color: "#85898F",
                            }}
                          >
                            <a href={i.link} className="menu-link" target="_blank" rel="noreferrer">
                              {lang[i.url]}
                            </a>
                          </Typography>
                        </Box>
                      </Box>
                  );
                })}
              </Box>
            </Grid>
          </Grid>{" "}
          <Grid
            item
            xs={12}
            md={4}
            sx={{
              m: { lg: 0, xs: "20px 0px" },
              display: "flex",
              alignItems: "start",
              flexDirection: "column",
              padding: { lg: "0px 0 0 24px", xs: "0px" },
              minWidth: 0,
              maxWidth: "100%",
              boxSizing: "border-box",
            }}
          >
            <Typography
              sx={{
                marginTop: { lg: "0px", xs: "20px" },
                fontFamily: "'Manrope' !important",
                fontSize: "18px !important",
                fontWeight: "600 !important",
                lineHeight: "160% !important",
              }}
            >
              {lang["Join Our Newsletter"]}
            </Typography>

            <Box
              className="footer-newsletter"
              sx={{
                paddingTop: "20px",
                width: "100%",
                maxWidth: { lg: 340, xs: "100%" },
                minWidth: 0,
                boxSizing: "border-box",
              }}
            >
              <input
                className="footer-newsletter__email"
                placeholder={`${lang["Your email address"]}`}
                value={emailAddress}
                onChange={(e) => setEmailAddress(e.target.value)}
                disabled={isSubmitting}
                type="email"
                autoComplete="email"
              />

              <Box className="footer-newsletter__captcha">
                <Typography
                  component="label"
                  className="footer-newsletter__captcha-label"
                >
                  {lang["Anti-spam"]}{" "}
                  <Box component="span" sx={{ color: "#FBBF04", fontWeight: 600 }}>
                    {captchaQuestion || "…"}
                  </Box>
                </Typography>
                <input
                  className="footer-newsletter__captcha-input"
                  aria-label={lang["Anti-spam answer"]}
                  value={captchaAnswer}
                  onChange={(e) => setCaptchaAnswer(e.target.value)}
                  disabled={isSubmitting || !captchaToken}
                  type="number"
                  inputMode="numeric"
                />
              </Box>

              <IconButton
                className="iconbutton1 footer-newsletter__submit"
                onClick={subscribeHandler}
                disabled={isSubmitting}
                sx={{
                  height: "52px",
                  fontSize: { lg: "15px", xs: "14px" },
                  fontFamily: "'Manrope' !important",
                  fontWeight: 600,
                  lineHeight: "1.3",
                  borderRadius: "61px",
                  color: "#0F0F0E",
                  padding: "12px 20px",
                  backgroundColor: "#FBBF04",
                  width: "100%",
                  maxWidth: "100%",
                  boxSizing: "border-box",
                  whiteSpace: "normal",
                  "&.Mui-disabled": {
                    backgroundColor: "rgba(251, 191, 4, 0.45)",
                    color: "#0F0F0E",
                  },
                }}
              >
                {isSubmitting ? (lang["Sending…"] || "Sending…") : lang["Subscribe"]}
              </IconButton>
            </Box>
            <Typography
              sx={{
                marginTop: "21px",
                fontFamily: "'Manrope' !important",
                fontSize: { lg: "16px !important", xs: "12px" },
                fontWeight: "400 !important",
                lineHeight: "170% !important",
                width: "100%",
                maxWidth: { lg: 340, xs: "100%" },
                color: "#85898F",
              }}
            >
              {lang["Will send you weekly updates for your better finance management."]}
            </Typography>
          </Grid>
        </Grid>
        
      </Grid>
    </>
  );
};

export default Footer;
